export default "__VITE_ASSET__C7R1sv2R__"